<template>
  <div>
    <div class="glz animation srcospcur">
      <img src="/static/management/glbg1.jpg" />
      <div class="whbfb txt1">
        <div class="table">
          <div class="table-cell">
            <h5 class="ft44">肩负使命 心怀梦想</h5>
            <p>积极进取、创造力、激情以自愿为基础,肩负使命,心怀梦想人人参与决策,创意民主化共同进步,一同分享成长的光荣</p>
          </div>
        </div>
      </div>
    </div>
    <div class="lclists animation" ref="lclists">
      <div
        v-for="(item) in list.slice(1)"
        :key="item.id"
        class="li"
        :class="item.isActive?'cur':''"
        :style="{width: item.isActive?boxw:'56px'}"
        @mouseenter.stop="mouseOverFun(item)"
        @mouseleave.stop="mouseLeaveFun(item)"
      >
        <div class="tit ft24">
          <div class="table">
            <div class="table-cell">{{item.listTitle}}</div>
          </div>
        </div>
        <div class="con" style="width: 640px;" :style="{display:item.isActive?'block':''}">
          <img :src="item.imageUrl" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object, Array]
  },
  data() {
    return {
      boxw: "690px",
      list: this.$props.data || []
    };
  },
  computed: {
    activeNum() {
      let flag = 0;
      this.list.forEach(cell => {
        if (cell.isActive) {
          flag++;
        }
      });
      return flag;
    }
  },
  created() {
    if (this.$props.data.length > 0) {
      let arr = this.$props.data.map(item => {
        item.isActive = false;
        return item;
      });
      arr[1].isActive = true;
      this.$set(this.$data, "list", arr);
    }
  },
  mounted() {
    window.addEventListener("load", () => {
      let cons = document.querySelectorAll(".con");
      let w = this.$refs.lclists.clientWidth;
      cons.forEach(item => {
        item.style.width = w - 224 - 56 + "px";
      });
      this.boxw = w - 224 + "px";
    });
    window.addEventListener("resize", () => {
      let cons = document.querySelectorAll(".con");
      let w = this.$refs.lclists.clientWidth;
      cons.forEach(item => {
        item.style.width = w - 224 - 56 + "px";
      });
      this.boxw = w - 224 + "px";
    });
  },
  methods: {
    mouseOverFun(item) {
      let arr = JSON.parse(JSON.stringify(this.list));
      arr.forEach(cell => {
        if (cell.id == item.id) {
          cell.isActive = true;
        } else {
          cell.isActive = false;
        }
      });
      this.$set(this.$data, "list", arr);
    },
    mouseLeaveFun() {}
  }
};
</script>